import { fetchAuthSession, signInWithRedirect  } from 'aws-amplify/auth';

export async function fetchCurrentSession() {
  try {
    const { tokens } = await fetchAuthSession({ forceRefresh: true });
    return tokens?.idToken?.payload
  } catch (err) {
    console.log("fetchCurrentSession Error", err);
  }
}

export async function fetchCurrentIdToken() {
  try {
    const { tokens } = await fetchAuthSession({ forceRefresh: true });
    const idToken = tokens?.idToken?.toString();
    return idToken;
  } catch (err) {
    console.log("fetchCurrentIdToken Error", err);
  }
}

export function redirectToLogIn(redirectPath = ''){
    let path = redirectPath
    
    if(!!window.location.pathname && !path) {
        path = window.location.pathname
        if(window.location.search) {
            path += window.location.search
        }
    }

    const signIn = signInWithRedirect({
      provider: {
        custom: process.env.REACT_APP_SAML_PROVIDER,
      },
      customState: (path || '/')
    });

    return signIn
}